<template>
    <section class="catalog">
        <div class="mobile-block" v-if="cat !== null && page.catalog_type === 'group'">
            <a @click="clearCat()">{{ cat.title }} <span class="--clear-cat --close-button"></span></a>
        </div>
        <div class="container" v-if="groups.length">
            <div class="catalog-cats">
                <p class="--section-title">Выберите тип {{ page.tech_type_text }}</p>
                <div class="catalog-cats-content vpf" data-ps="true">
                    <!--                <VuePerfectScrollbar class="catalog-cats-content" v-once @ps-scroll-y="scrollHandle">-->
                    <div class="catalog-cats-columns">
                        <div class="catalog-cats-column" v-for="(group, gid) in groups"
                             v-if="group.cats.length">
                            <p class="catalog-cats-column-title">{{ group.site_name }}</p>

                            <a v-for="(cat_elem, cid) in group.cats"
                               @click="setActiveCat($event, gid, cid)"

                               :data-cat_id="cat_elem.id"
                               :class="[cat !== null && cat.id === cat_elem.id ? '--active' : '']"

                               href="#tech-catalog-block" class="catalog-cats-column-link">
                                <span v-if="cat_elem.small_image !== null"
                                      :style="'background-image: url(/storage/content/'+cat_elem.small_image+')'"
                                ></span><span v-else
                                              :style="'background-image: url(/storage/content/'+cat_elem.image+')'"
                            ></span> {{ cat_elem.title }} <span class="--clear-cat --close-button"></span></a>

                        </div>

                    </div>
                    <!--                </VuePerfectScrollbar>-->
                </div>
            </div>
        </div>
        <div class="container" id="tech-catalog-block">
            <div class="catalog-tech">
                <p class="--section-title" v-if="groups.length && cat === null">
                    <span v-if="page.gender === 'male'">Все</span>
                    <span v-else>Вся</span>
                    {{ page.kto_mnoj }} ({{ groups.reduce((s, a) => s + a.tech_count, 0) }})
                </p>
                <p class="--section-title"
                   v-if=" cat !== null ">
                    {{ cat.title }} ({{ cat.tech_count }})
                </p>
                <!--<p class="&#45;&#45;section-title"
                   v-if=" cat !== null || page.catalog_type === 'cat'">
                    {{ cat.title }} ({{ cat.tech_count }})
                </p>-->
                <div class="catalog-tech-filters"
                     v-if="filter_list !== null && filter_list.length && page.filters === 1">
                    <div class="catalog-tech-filter" v-for="(filter, fid) in filter_list"
                         v-if="typeof currentFilters[filter] !== 'undefined'">
                        <p class="--filter-title">{{ filters[filter].page_name }}</p>
                        <div class="--filter-buttons" v-dragscroll="true"
                             @dragscrollstart="blockClick"
                             @dragscrollend="enableClick"
                             :class="scrollStart ? '--block-click' : ''"
                        >
                            <button

                                :disabled="useFilterBlock === true && enabled_filters[filter] !== undefined && !enabled_filters[filter].includes(fvalue)"
                                :data-filter="filter" :data-filter_value="fvalue"
                                :class="[
                                        active_filters[filter] !== undefined && active_filters[filter].includes(fvalue) ? '--active' : '',
                                        fvid >= filter_buttons_limit && showAllActive === false ? '--hidden' : '']"
                                type="button" class="--button --transparent-button"
                                @click="setFilter(filter, fvalue)"
                                v-for="(fvalue, fvid) in currentFilters[filter]">
                                {{ fvalue }}
                                <span @click="clearFilter(filter)" class="--close-button --clear-filter"></span>
                            </button>
                            <button @click="showAllButtons($event,filter)"
                                    v-if="currentFilters[filter].length > filter_buttons_limit" type="button"
                                    class="--button --text-button --text-button-svg">
                                Показать все ({{ currentFilters[filter].length - filter_buttons_limit }})
                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M0.183057 0.195261C0.427138 -0.0650868 0.822864 -0.0650868 1.06695 0.195261L5.00001 4.39055L8.93308 0.195261C9.17714 -0.0650868 9.57289 -0.0650868 9.81695 0.195261C10.061 0.455615 10.061 0.877723 9.81695 1.13808L5.44195 5.80475C5.19788 6.06508 4.80213 6.06508 4.55807 5.80475L0.183057 1.13808C-0.0610188 0.877723 -0.0610188 0.455615 0.183057 0.195261Z"
                                          fill="#939393"/>
                                </svg>

                            </button>
                        </div>
                    </div>
                    <div class="catalog-tech-filter">
                        <p class="--filter-title">Сортировка</p>
                        <div class="--filter-buttons" v-dragscroll="true">
                            <button type="button" class="--button --transparent-button"
                                    :class="[active_sort === 'popular'? '--active' : '']"
                                    @click="setSort('popular')"
                            >
                                По популярности
                            </button>
                            <button type="button" class="--button --transparent-button"
                                    :class="[active_sort === 'price_acs'? '--active' : '']"
                                    @click="setSort('price_acs')">
                                Цена
                                <svg width="12" height="16" viewBox="0 0 12 16" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M11.7708 6.08999C12.0764 5.806 12.0764 5.34551 11.7708 5.0615L6.55337 0.213011C6.24774 -0.0710036 5.75229 -0.0710036 5.44666 0.213011L0.229221 5.0615C-0.0764038 5.34551 -0.0764038 5.806 0.229221 6.08999C0.534846 6.37401 1.03037 6.37401 1.336 6.08999L5.2174 2.48306V10.4242C5.2174 11.1159 4.98763 12.1697 4.32137 13.0296C3.6839 13.8524 2.6145 14.5455 0.78261 14.5455C0.35039 14.5455 0 14.8711 0 15.2727C0 15.6744 0.35039 16 0.78261 16C3.12464 16 4.66394 15.0768 5.5917 13.8795C6.49066 12.7192 6.78262 11.3488 6.78262 10.4242V2.48306L10.6641 6.08999C10.9697 6.37401 11.4651 6.37401 11.7708 6.08999Z"
                                          fill="#939393"/>
                                </svg>

                            </button>
                            <button type="button" class="--button --transparent-button"
                                    :class="[active_sort === 'price_desc'? '--active' : '']"
                                    @click="setSort('price_desc')"
                            >
                                Цена
                                <svg width="12" height="16" viewBox="0 0 12 16" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M11.7708 9.91003C12.0764 10.1941 12.0764 10.6545 11.7708 10.9385L6.55337 15.787C6.24774 16.071 5.75229 16.071 5.44666 15.787L0.229221 10.9385C-0.0764038 10.6545 -0.0764038 10.1941 0.229221 9.91003C0.534846 9.626 1.03037 9.626 1.336 9.91003L5.2174 13.5169V5.57577C5.2174 4.88406 4.98763 3.83032 4.32137 2.97041C3.6839 2.14757 2.6145 1.45455 0.78261 1.45455C0.35039 1.45455 0 1.12893 0 0.727274C0 0.325615 0.35039 0 0.78261 0C3.12464 0 4.66394 0.923133 5.5917 2.12051C6.49066 3.2808 6.78262 4.6513 6.78262 5.57577V13.5169L10.6641 9.91003C10.9697 9.626 11.4651 9.626 11.7708 9.91003Z"
                                          fill="#939393"/>
                                </svg>

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="catalog-tech-cards">
            <div class="container d-flex flex-column justify-content-center">
                <div class="catalog-tech-card" :data-tech_id="tid" v-for="(tech, tid) in view_tech">
                    <div class="tech-info">
                        <div class="tech-info-head">
                            <div class="tech-info-head-image">
                                <img :src="'/storage/content/'+tech.image"/>
                            </div>
                            <p class="tech-info-title">{{ tech.title }}</p>
                        </div>
                        <div class="tech-info-specs">
                            <div class="tech-info-image">
                                <img :src="'/storage/content/'+tech.image"/>
                            </div>
                            <div class="tech-info-spec">
                                <p class="tech-info-spec-title" data-target_open_specs
                                   :data-specs="tech.id">Технические характеристики</p>
                                <ul class="tech-info-spec-list" :data-specs_list="tech.id">
                                    <li v-for="(v,k) in tech.spec">{{ k }}: {{ v }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="tech-form">
                        <p data-target-open-price_param
                           :data-price_param="tech.id" class="tech-form-param-title">Варианты заказа и
                            цен</p>
                        <div class="tech-form-param-block" :data-price_param_block="tech.id">
                            <div class="tech-form-param">
                                <p class="tech-form-title">Выберите тип предоставления техники</p>
                                <div class="tech-form-param-buttons">
                                    <button
                                        @click="changeSinglePriceType($event, 'service', tid)"

                                        data-change_type_button
                                        :data-tech_id="tid"
                                        type="button"
                                        class="--button --transparent-button"
                                        :class="[price_type === 'service' ? '--active' : '']"
                                    >С оператором
                                    </button>
                                    <button
                                        @click="changeSinglePriceType($event, 'rent', tid)"
                                        type="button"
                                        :data-tech_id="tid"
                                        data-change_type_button
                                        :class="[price_type === 'rent' ? '--active' : '']"
                                        class="--button --transparent-button">Аренда без оператора
                                    </button>
                                </div>
                            </div>
                            <div class="tech-form-param" data-service-buttons-block :data-tech_id="tid"
                                 :class="[price_type === 'service' ? '' : '--hidden']">
                                <p class="tech-form-title">Выберите количество смен</p>
                                <div class="tech-form-param-buttons">
                                    <button
                                        :data-service_button="tid"
                                        @click="changeSmenaCount($event, tid,tech.price)"
                                        type="button"
                                        class="--button --transparent-button"
                                    >до 14
                                    </button>
                                    <button type="button"
                                            :data-service_button="tid"
                                            @click="changeSmenaCount($event, tid,tech.price_14)"
                                            class="--button --transparent-button">14–30
                                    </button>
                                    <button type="button"
                                            :data-service_button="tid"
                                            @click="changeSmenaCount($event, tid,tech.price_30)"
                                            class="--button --transparent-button">30–90
                                    </button>
                                    <button type="button"
                                            :data-service_button="tid"
                                            @click="changeSmenaCount($event, tid,tech.price_90)"
                                            class="--button --transparent-button --active">от 90
                                    </button>
                                </div>
                            </div>
                            <div class="tech-form-param" data-rent-buttons-block :data-tech_id="tid"
                                 :class="[price_type === 'rent' ? '' : '--hidden']">
                                <p class="tech-form-title">Выберите срок аренды (дней)</p>
                                <div class="tech-form-param-buttons">
                                    <button
                                        :data-rent_button="tid"
                                        @click="changeArandaCount($event, tid,tech.rent_30)"
                                        type="button"
                                        class="--button --transparent-button"
                                    >30–90
                                    </button>
                                    <button type="button"
                                            :data-rent_button="tid"
                                            @click="changeArandaCount($event, tid,tech.rent_90)"
                                            class="--button --transparent-button">90–180
                                    </button>
                                    <button type="button"
                                            :data-rent_button="tid"
                                            @click="changeArandaCount($event, tid,tech.rent_180)"
                                            class="--button --transparent-button">180–360
                                    </button>
                                    <button type="button"
                                            :data-rent_button="tid"
                                            @click="changeArandaCount($event, tid,tech.rent_360)"
                                            class="--button --transparent-button --active">от 360
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="tech-form-price" data-service-price-block :data-tech_id="tid"
                             :class="[price_type === 'service' ? '' : '--hidden']">
                            <div class="tech-form-price-block">
                                <p class="tech-form-price-block-title">За смену 8 часов</p>
                                <span data-price_service_smena :data-tech_id="tid">{{ formatPrice(tech.price_90 * 8) }} ₽</span>
                            </div>
                            <div class="tech-form-price-block">
                                <p class="tech-form-price-block-title">За час</p>
                                <span data-price_service_hour
                                      :data-tech_id="tid">{{ formatPrice(parseInt(tech.price_90)) }} ₽</span>
                            </div>
                            <div class="--price-delimiter"></div>
                        </div>
                        <div class="tech-form-price" data-rent-price-block :data-tech_id="tid"
                             :class="[price_type === 'rent' ? '' : '--hidden']">
                            <div class="tech-form-price-block">
                                <p class="tech-form-price-block-title">Стоимость за сутки</p>
                                <span data-price_rent :data-tech_id="tid">{{
                                        formatPrice(parseInt(tech.rent_360))
                                    }} ₽</span>
                            </div>
                        </div>

                        <button data-bs-toggle="modal" data-bs-target="#productModal"
                                type="button" class="--button --color-button w100" @click="orderTech(tid)">Заказать
                        </button>
                    </div>
                </div>
                <button style="width: 222px;
  margin: 0 auto;" class="--button --color-button load-more-button" @click="addTech" v-if="tech_list.length">
                    Показать следующие

                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M13.7437 7.69526C13.402 7.43491 12.848 7.43491 12.5063 7.69526L6.99999 11.8905L1.49369 7.69526C1.15201 7.43491 0.597954 7.43491 0.256266 7.69526C-0.0854216 7.95561 -0.0854216 8.37772 0.256266 8.63808L6.38128 13.3047C6.72296 13.5651 7.27701 13.5651 7.6187 13.3047L13.7437 8.63808C14.0854 8.37772 14.0854 7.95561 13.7437 7.69526Z"
                              fill="white"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M13.7437 0.695261C13.402 0.434913 12.848 0.434913 12.5063 0.695261L6.99999 4.89055L1.49369 0.695261C1.15201 0.434913 0.597954 0.434913 0.256266 0.695261C-0.0854216 0.955615 -0.0854216 1.37772 0.256266 1.63808L6.38128 6.30475C6.72296 6.56508 7.27701 6.56508 7.6187 6.30475L13.7437 1.63808C14.0854 1.37772 14.0854 0.955615 13.7437 0.695261Z"
                              fill="white"/>
                    </svg>

                </button>

            </div>
        </div>
    </section>
</template>

<script>
//import VuePerfectScrollbar from 'vue-perfect-scrollbar'


import PerfectScrollbar from "perfect-scrollbar";

export default {

    name: "TechCatalog",
    props: ['page_id', 'price_type', 'default_filters'],
    components: {
        //      VuePerfectScrollbar
    },
    mounted() {

        this.loadData();
        document.addEventListener('click', (e) => {
            let target = e.target;
            if (target.hasAttribute('data-target_open_specs')) {
                let specId = target.getAttribute('data-specs');
                let specList = document.querySelector(`[data-specs_list="${specId}"]`);
                if (specList) {
                    if (target.classList.contains('--active')) {
                        target.classList.remove('--active')
                        specList.classList.remove('--active');
                    } else {
                        target.classList.add('--active')
                        specList.classList.add('--active');
                    }
                }
            }
            if (target.hasAttribute('data-target-open-price_param')) {
                let priceId = target.getAttribute('data-price_param');
                let paramBlock = document.querySelector(`[data-price_param_block="${priceId}"]`);
                if (paramBlock) {
                    if (target.classList.contains('--active')) {
                        target.classList.remove('--active')
                        paramBlock.classList.remove('--active');
                    } else {
                        target.classList.add('--active')
                        paramBlock.classList.add('--active');
                    }
                }
            }
        });
    },
    data() {
        return {
            scrollStart: false,
            showAllActive: false,
            hideEmptyFilter: true,
            useFilterBlock: false,
            defaultFiltersInit: false,
            tech_per_page: 10,
            //current_page: -1,
            filter_buttons_limit: 6,
            page: {
                filters: 0,
                filters_list: [],
                gender: '',
                tech_type_text: '',
                kto_mnoj: '',
                group_list: [],
                catalog_type: 'cat',
                catalog: []
            },

            groups: [],
            cat: null,
            tech: [],
            view_tech: [],

            filters: [],
            filter_list: [],
            tech_filters: [],

            currentFilters: {},

            enabled_filters: {},

            active_filters: {},

            active_sort: 'popular'
        }
    },
    methods: {
        setSort(sort) {
            this.active_sort = sort;
        },
        blockClick(event) {
            this.scrollStart = true;
        },
        enableClick(event) {
            this.scrollStart = false;
        },
        clearFilter(filter) {
            //this.$delete(this.active_filters, filter);
        },
        scrollHandle() {
            /*  const catList = document.querySelectorAll('.vpf');
              catList.forEach((elem) => {
                  new PerfectScrollbar(elem);
              })*/

        },
        formatPrice(price) {
            return new Intl.NumberFormat('ru-RU', {
                style: 'currency',
                currency: 'RUB',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                currencyDisplay: "code"
            }).format(
                price,
            ).replace("RUB", "")
                .trim()
        },
        orderTech(tid) {
            let modalContainer = document.getElementById('productModal');
            let tech = this.view_tech[tid];
            if (modalContainer) {
                let modalTitle = modalContainer.querySelector('[data-tech_modal_title]');
                let modalImage = modalContainer.querySelector('[data-tech_modal_image]');
                let modalProductId = modalContainer.querySelector('[name="product_id"]');
                let modalTechId = modalContainer.querySelector('[name="tech_id"]');
                if (modalTechId)
                    modalTechId.value = tech.id;
                if (modalProductId)
                    modalProductId.value = tech.id;

                if (modalTitle)
                    modalTitle.innerText = tech.title;
                if (modalImage)
                    modalImage.style.backgroundImage = `url('/storage/content/${tech.image}'`;

                let modal = bootstrap.Modal.getOrCreateInstance(modalContainer);
                modal.show();
            }
        },
        changeSinglePriceType($event, type, tid) {
            let buttons = document.querySelectorAll('[data-change_type_button][data-tech_id="' + tid + '"]');
            buttons.forEach((b) => {
                b.classList.remove('--active');
            });


            let button = $event.target;
            button.classList.add('--active');


            let rentTypeInput = document.querySelector('#tech_modal_form [name="rent_type"]');
            if (rentTypeInput)
                rentTypeInput.value = button.innerText;


            let data_service_buttons_block = document.querySelector('[data-service-buttons-block][data-tech_id="' + tid + '"]');
            let data_service_price_block = document.querySelector('[data-service-price-block][data-tech_id="' + tid + '"]');

            let data_rent_buttons_block = document.querySelector('[data-rent-buttons-block][data-tech_id="' + tid + '"]');
            let data_rent_price_block = document.querySelector('[data-rent-price-block][data-tech_id="' + tid + '"]');


            if (data_rent_buttons_block, data_service_buttons_block, data_service_price_block, data_rent_price_block) {
                if (type === 'service') {
                    data_service_buttons_block.classList.remove('--hidden');
                    data_service_price_block.classList.remove('--hidden');

                    data_rent_buttons_block.classList.add('--hidden');
                    data_rent_price_block.classList.add('--hidden');
                }
                if (type === 'rent') {
                    data_rent_buttons_block.classList.remove('--hidden');
                    data_rent_price_block.classList.remove('--hidden');

                    data_service_buttons_block.classList.add('--hidden');
                    data_service_price_block.classList.add('--hidden');
                }
            }

        },
        changeArandaCount($event, tid, price) {
            let button = $event.target;

            let rentCountInput = document.querySelector('#tech_modal_form [name="rent_count"]');
            if (rentCountInput)
                rentCountInput.value = button.innerText;

            let buttons = document.querySelectorAll('[data-rent_button="' + tid + '"]');
            buttons.forEach((b) => {
                b.classList.remove('--active');
            })
            button.classList.add('--active');
            let priceContainer = document.querySelector('[data-price_rent][data-tech_id="' + tid + '"]');
            if (priceContainer)
                priceContainer.innerText = `${this.formatPrice(parseInt(price))}  ₽`;
        },
        changeSmenaCount($event, tid, price) {
            let button = $event.target;

            let rentCountInput = document.querySelector('#tech_modal_form [name="rent_count"]');
            if (rentCountInput)
                rentCountInput.value = button.innerText;

            let buttons = document.querySelectorAll('[data-service_button="' + tid + '"]');
            buttons.forEach((b) => {
                b.classList.remove('--active');
            })
            button.classList.add('--active');
            let priceSmenaContainer = document.querySelector('[data-price_service_smena][data-tech_id="' + tid + '"]');
            let priceHourContainer = document.querySelector('[data-price_service_hour][data-tech_id="' + tid + '"]');

            if (priceHourContainer)
                priceHourContainer.innerText = `${this.formatPrice(parseInt(price))}  ₽`;
            if (priceSmenaContainer)
                priceSmenaContainer.innerText = `${this.formatPrice(parseInt(price) * 8)}  ₽`;

        },
        clearCat() {
            this.cat = null;
            this.active_filters = {};
        },
        setActiveCat($event, gid, cid) {

            if (this.cat !== null && this.cat.id === this.groups[gid].cats[cid].id) {
                $event.preventDefault();
                this.cat = null;
                this.filter_list = this.page.filters_list;
            } else {
                this.cat = this.groups[gid].cats[cid];
                this.filter_list = this.cat.filters;
                //this.view_tech = this.tech_list.splice(0, this.tech_per_page);
            }
            this.active_filters = {};


        },
        setFilter(filter, value) {
            const vm = this;
            /*let buttons = document.querySelectorAll('[data-filter="' + filter + '"]');
            buttons.forEach((b) => {
                b.classList.remove('--active');
                if (b.getAttribute('data-filter_value') === value)
                    b.classList.add('--active');
            });*/


            if (typeof this.active_filters[filter] !== "undefined" && this.active_filters[filter].includes(value)) {
                //this.$delete(this.active_filters, filter);
                let valueKey = Object.keys(this.active_filters[filter]).find(key => this.active_filters[filter][key] === value);

                this.$delete(this.active_filters[filter], valueKey);

            } else {
                if (this.active_filters[filter] === undefined)
                    this.$set(this.active_filters, filter, []);

                if (this.active_filters[filter].includes(value) === false)
                    this.active_filters[filter].push(value);
            }
            //this.active_filters[filter] = value;
            //this.$set(this.active_filters, filter, value);
        },
        loadData() {
            const vm = this;
            axios.get('/get-data/' + this.page_id).then((response) => response.data)
                .then((data) => {
                    vm.groups = data.groups;

                    vm.page = data.page;
                    vm.filter_list = data.page.filters_list;

                    vm.cat = data.cat;
                    vm.tech = data.tech;
                    vm.filters = data.filters;
                    vm.tech_filters = data.tech_filters;
                    vm.addTech(false);
                    //vm.view_tech = data.tech.splice(0, vm.tech_per_page);
                    //vm.initPF();
                    return true;
                }).then((result) => {
                let groupsElem = document.querySelector('.vpf');
                if (groupsElem)
                    new window.PerfectScrollbar(groupsElem);

                if (this.defaultFiltersInit === false && Object.keys(this.tech_filters).length !== 0) {
                    let df = JSON.parse(JSON.stringify(this.default_filters));
                    /*for (let [key, obj] of Object.entries(df)) {
                        df[key].forEach((elem) => {
                            if (vm.currentFilters[key] !== undefined && vm.currentFilters[key].includes(elem))
                                dfArr.push(elem);
                        })
                        vm.$set(vm.active_filters, key, dfArr);
                    }*/
                    for (let [key, obj] of Object.entries(df)) {
                        let dfArr = [];
                        df[key].forEach((elem) => {
                            if (vm.tech_filters[key] !== undefined && vm.tech_filters[key].includes(elem)) {
                                dfArr.push(elem);
                            }
                        })
                        df[key] = dfArr;
                    }
                    //vm.active_filters = df;
                    vm.$set(vm, 'active_filters', df);
                    this.defaultFiltersInit = true;
                }


            })
        },
        addTech(clean) {
            //this.view_tech.concat(this.tech.splice(3,3));
            const vm = this;

            if (clean === true) {
                vm.view_tech = [];
            }

            //vm.current_page = vm.current_page + 1;

            //this.tech_list.splice(vm.current_page * vm.tech_per_page, vm.tech_per_page).forEach((elem) => {
            this.tech_list.splice(0, vm.tech_per_page).forEach((elem) => {
                    vm.view_tech.push(elem);
                }
            );
        },
        showAllButtons(event, filter) {
            this.showAllActive = true;
            event.target.remove();
            let buttons = document.querySelectorAll('button[data-filter="' + filter + '"]');
            buttons.forEach((btn) => {
                btn.classList.remove('--hidden');
            });
        }
    },
    watch: {
        'groups': {
            handler(val) {

            }
        },
        'active_sort': {
            handler(val, oldVal) {
                this.addTech(true);
            }
        },
        'active_filters': {
            handler(val, oldVal) {
                this.addTech(true);
            },
            deep: true
        }
    },
    computed: {
        tech_list() {
            const vm = this;
            let techArr = [];

            if (this.cat !== null) {
                techArr = JSON.parse(JSON.stringify(this.cat.tech));
            } else {
                techArr = JSON.parse(JSON.stringify(this.tech));
            }

            let currentFilters = {};

            techArr.forEach((elem) => {
                for (let [key, obj] of Object.entries(elem.filters)) {

                    if (currentFilters[key] === undefined)
                        currentFilters[key] = [];

                    obj.forEach((v) => {
                        if (currentFilters[key].includes(v) === false)
                            currentFilters[key].push(v);
                    })


                }
            });


            if (this.hideEmptyFilter)
                this.currentFilters = currentFilters;
            else
                this.currentFilters = this.tech_filters;

            if (Object.keys(this.active_filters).length) {/*
                for (let [key, obj] of Object.entries(this.active_filters)) {
                    techArr = techArr.filter(tech => tech.filters[key].includes(obj));
                }*/
                for (let [key, obj] of Object.entries(this.active_filters)) {

                    techArr = techArr.filter((tech) => {

                        if (vm.active_filters[key] === undefined || vm.active_filters[key].length === 0)
                            return true;

                        let state = false
                        tech.filters[key].forEach((elem) => {
                            if (vm.active_filters[key].includes(elem))
                                state = true;
                        })
                        return state;
                    });
                }
            }

            //console.log(techArr);

            let enabledFilters = {};
            techArr.forEach((elem) => {
                for (let [key, obj] of Object.entries(elem.filters)) {

                    if (enabledFilters[key] === undefined)
                        enabledFilters[key] = [];

                    obj.forEach((v) => {
                        if (enabledFilters[key].includes(v) === false)
                            enabledFilters[key].push(v);
                    })


                }
            });

            if (this.useFilterBlock)
                this.enabled_filters = enabledFilters;
            else
                this.enabled_filters = this.currentFilters;


            if (this.active_sort === 'price_acs') {
                techArr.sort((a, b) => {
                    return a.price_90 - b.price_90;
                })
            }
            if (this.active_sort === 'price_desc') {
                techArr.sort((a, b) => {
                    return b.price_90 - a.price_90;
                })
            }
            if (this.active_sort === 'popular') {
                if (this.page.catalog_type === 'group' && this.page.kto_mnoj === 'спецтехника')
                    techArr.sort((a, b) => {
                        return a.position_page_specteh - b.position_page_specteh;
                    })
                else if (this.page.catalog_type === 'group' && this.page.kto_mnoj === 'экскаваторы') {
                    techArr.sort((a, b) => {
                        return a.position_page_ekskavator - b.position_page_ekskavator;
                    })
                } else if (this.page.catalog_type === 'group' && this.page.kto_mnoj === 'погрузчики') {
                    techArr.sort((a, b) => {
                        return a.position_page_pogruz - b.position_page_pogruz;
                    })
                } else if (this.page.catalog_type === 'group' && this.page.kto_mnoj === 'подъёмники') {
                    techArr.sort((a, b) => {
                        return a.position_page_podym - b.position_page_podym;
                    })
                } else
                    techArr.sort((a, b) => {
                        return a.position - b.position;
                    })
            }

            return techArr;
        }
    }
}
</script>

<style scoped lang="scss">
.load-more-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.--block-click {
    pointer-events: none;
}

.--clear-filter {
    top: -11px;
    right: -11px;
}

#tech-catalog-block {
    @media(max-width: 991px) {
        scroll-margin-top: 150px;
    }
}

</style>
